module.exports = __webpack_public_path__ + "img/KleineFuge.03a44c2c.jpg";